import { query } from '@confluence/query-preloader-tools';

import { OperationsQuery } from './OperationsQuery.graphql';

export function preloadOperations() {
	return query({ query: OperationsQuery });
}
